module.exports = __webpack_public_path__ + "media/winter_2025_sweepstakes/2025k-scholarship-success-logo-lock-up-6cb72b08.png";